import React, { Fragment, useState, useCallback, useEffect } from 'react'
import NumberFormat from 'react-number-format'
import DashboardService from '../../services/dashboard.service'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import AssetsIcon from 'custom/assets/common-icons/Asset.svg'
import LiabilitiesIcon from 'custom/assets/common-icons/Liabilities.svg'
import { Card, CardDeck } from 'react-bootstrap'
import './portfolio.css'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion'
import Loading from 'custom/assets/loaders/Loading'
import { useTranslation } from 'react-i18next'
import { PORTFOLIO_KEYS } from '../../utils/translation-constants'
import env from 'custom/config/environment'

export default function Portfolio() {
  const { t } = useTranslation()
  const accountTypes = {
    D: `${t(PORTFOLIO_KEYS.TD_ACCOUNT)}`,
    S: `${t(PORTFOLIO_KEYS.SAVINGS_ACCOUNT)}`,
    C: `${t(PORTFOLIO_KEYS.CURRENT_ACCOUNT)}`,
    L: `${t(PORTFOLIO_KEYS.LOAN_ACCOUNT)}`,
  }

  const [loading, setLoading] = useState(true)
  const [assetsList, setAssetsList] = useState([])
  const [currentList, setCurrentList] = useState([])
  const [liabilityList, setLiabilityList] = useState([])
  const [depositList, setDepositList] = useState([])
  const [assetsCount, setAssetsCount] = useState(0)
  const [liabilityCount, setLiabilityCount] = useState(0)
  const [currency, setCurrency] = useState('')

  useEffect(() => {
    assetsAndLiabilities()
  }, [])

  const assetsAndLiabilities = useCallback(async () => {
    setLoading(true)
    try {
      const response = await DashboardService.assetsAndLiabilities({})

      if (response.status === 200) {
        setLoading(false)
        setAssetsList(
          response.data['accounts'].filter((e) => env.SAVING_ACCOUNT_TYPES.includes(e.accType)),
        )
        setCurrentList(
          response.data['accounts'].filter((e) => env.CURRENT_ACCOUNT_TYPES.includes(e.accType)),
        )
        setLiabilityList(
          response.data['accounts'].filter((e) => env.LOAN_ACCOUNT_TYPES.includes(e.accType)),
        )
        setDepositList(
          response.data['accounts'].filter((e) => env.DEPOSIT_ACCOUNT_TYPES.includes(e.accType)),
        )
        setAssetsCount(response.data['assets'])
        setLiabilityCount(response.data['liability'])
        setCurrency(response.data['currency'])
      }
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='PORTFOLIO'>
      {loading && renderLoading()}
      {!loading && (
        <div className='row'>
          <CardDeck className='w-100'>
            <Card className='rounded-2'>
              <div className='portfolio'>
                <div className='portfolio-card'>
                  <div className='d-flex justify-content-between pt-4'>
                    <div>
                      <img className='icon mr-1' src={AssetsIcon} />
                      <h5 className='label-text-style d-inline-block'>
                        {t(PORTFOLIO_KEYS.ASSETS)}
                      </h5>
                    </div>
                    <h2 className='d-flex font-weight-600 align-items-center currency-style'>
                      <span className=''>{currency}</span>
                      <NumberFormat
                        className='ml-2'
                        value={assetsCount}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        allowEmptyFormatting
                      />
                     
                    </h2>
                  </div>
                  <div style={{ marginTop: 25 }}>
                    <Accordion
                      id='assetsAccordion'
                      allowZeroExpanded={true}
                      preExpanded={['custom-accr-0', 'custom-accr-1', 'custom-accr-2']}
                      allowMultipleExpanded={false}>
                      <AccordionItem uuid={`custom-accr-0`}>
                        <AccordionItemState>
                          {({ expanded }) => (
                            <Fragment>
                              <AccordionItemHeading className={'border-bottom-accordian'}>
                                <AccordionItemButton
                                  style={{ paddingLeft: 0, paddingRight: 0, fontWeight: 'bold' }}>
                                  <div className=' row'>
                                    <span className='col-sm-10'>
                                      {t(PORTFOLIO_KEYS.CURRENT_ACCOUNT)}
                                    </span>
                                    <i className='icon material-icons col-sm-2 '>
                                      keyboard_arrow_down
                                    </i>
                                  </div>
                                </AccordionItemButton>
                              </AccordionItemHeading>
                              <AccordionItemPanel className='pb-0'>
                                <ul style={{ listStyle: 'none', padding: 8 }}>
                                  {currentList.length === 0 && (
                                    <li>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</li>
                                  )}
                                  {currentList.map((item, i) => (
                                    <li key={i}>
                                      <div
                                        className='d-flex d-flex-content'
                                        style={{
                                          justifyContent: 'space-between',
                                          padding: '8px 0',
                                          borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                          fontSize: '12px',
                                          fontWeight: 600,
                                        }}>
                                        <span>{item.accNo}</span>
                                        <span>
                                          {item.accCurrecny}
                                          <NumberFormat
                                            className='ml-1'
                                            value={item.balance}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={''}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            allowEmptyFormatting
                                          />
                                        </span>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </AccordionItemPanel>
                            </Fragment>
                          )}
                        </AccordionItemState>
                      </AccordionItem>
                      <AccordionItem uuid={`custom-accr-1`}>
                        <AccordionItemState>
                          {({ expanded }) => (
                            <Fragment>
                              <AccordionItemHeading className={'border-bottom-accordian'}>
                                <AccordionItemButton
                                  style={{ paddingLeft: 0, paddingRight: 0, fontWeight: 'bold' }}>
                                  <div className='f-align row'>
                                    <span className='col-sm-10'>
                                      {t(PORTFOLIO_KEYS.SAVINGS_ACCOUNT)}
                                    </span>
                                    <i className='icon material-icons col-sm-2'>
                                      keyboard_arrow_down
                                    </i>
                                  </div>
                                </AccordionItemButton>
                              </AccordionItemHeading>
                              <AccordionItemPanel className='pb-0'>
                                <ul style={{ listStyle: 'none', padding: 8 }}>
                                  {assetsList.length === 0 && (
                                    <li>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</li>
                                  )}
                                  {assetsList.map((item, i) => (
                                    <li key={i}>
                                      <div
                                        className='d-flex d-flex-content'
                                        style={{
                                          justifyContent: 'space-between',
                                          padding: '8px 0',
                                          borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                          fontSize: '12px',
                                          fontWeight: 600,
                                        }}>
                                        <span>{item.accNo}</span>
                                        <span>
                                          {item.accCurrecny}
                                          <NumberFormat
                                            className='ml-1'
                                            value={item.balance}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={''}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            allowEmptyFormatting
                                          />
                                        </span>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </AccordionItemPanel>
                            </Fragment>
                          )}
                        </AccordionItemState>
                      </AccordionItem>
                      <AccordionItem uuid={`custom-accr-2`}>
                        <AccordionItemState>
                          {({ expanded }) => (
                            <Fragment>
                              <AccordionItemHeading>
                                <AccordionItemButton
                                  style={{ paddingLeft: 0, paddingRight: 0, fontWeight: 'bold' }}>
                                  <div className='f-align row'>
                                    <span className='col-sm-10'>
                                      {t(PORTFOLIO_KEYS.TD_ACCOUNT)}
                                    </span>
                                    <i className='icon material-icons col-sm-2'>
                                      keyboard_arrow_down
                                    </i>
                                  </div>
                                </AccordionItemButton>
                              </AccordionItemHeading>
                              <AccordionItemPanel className='pb-0'>
                                <ul style={{ listStyle: 'none', padding: 8 }}>
                                  {depositList.length === 0 && (
                                    <li>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</li>
                                  )}

                                  {depositList.map((item, i) => (
                                    <li key={i}>
                                      <div
                                        className='d-flex d-flex-content'
                                        style={{
                                          justifyContent: 'space-between',
                                          padding: '8px 0',
                                          borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                          fontSize: '12px',
                                          fontWeight: 600,
                                        }}>
                                        <span>{item.accNo}</span>
                                        <span>
                                          {item.accCurrecny}
                                          <NumberFormat
                                            className='ml-1'
                                            value={item.balance}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={''}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            allowEmptyFormatting
                                          />
                                        </span>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </AccordionItemPanel>
                            </Fragment>
                          )}
                        </AccordionItemState>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </div>
              </div>
            </Card>
            <Card className='rounded-2'>
              <div className='portfolio'>
                <div className='portfolio-card'>
                  <div className='d-flex justify-content-between pt-4'>
                    <div>
                      <img className='icon mr-1' src={LiabilitiesIcon} />
                      <h5 className='label-text-style d-inline-block'>
                        {t(PORTFOLIO_KEYS.LIABILITIES)}
                      </h5>
                    </div>
                    <h2 className='d-flex font-weight-600 align-items-center currency-style'>
                      <span className=''>{currency}</span>
                      <NumberFormat
                        className='ml-2'
                        value={liabilityCount}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        allowEmptyFormatting
                      />
                      
                    </h2>
                  </div>
                  <div style={{ marginTop: 25 }}>
                    <Accordion
                      id='liabilityAccordion'
                      allowZeroExpanded={true}
                      preExpanded={['custom-accr-0']}
                      allowMultipleExpanded={true}>
                      <AccordionItem uuid={`custom-accr-0`}>
                        <AccordionItemState>
                          {({ expanded }) => (
                            <Fragment>
                              <AccordionItemHeading className={'border-bottom-accordian'}>
                                <AccordionItemButton
                                  style={{ paddingLeft: 0, paddingRight: 0, fontWeight: 'bold' }}>
                                  <div className='f-align row'>
                                    <span className='col-sm-10'>
                                      {t(PORTFOLIO_KEYS.LOAN_ACCOUNT)}
                                    </span>
                                    <i className='icon material-icons col-sm-2'>
                                      keyboard_arrow_down
                                    </i>
                                  </div>
                                </AccordionItemButton>
                              </AccordionItemHeading>
                              <AccordionItemPanel className='pb-0'>
                                <ul style={{ listStyle: 'none', padding: 8 }}>
                                  {liabilityList.length === 0 && (
                                    <li>{t(PORTFOLIO_KEYS.NO_ACCOUNTS)}</li>
                                  )}

                                  {loading ? (
                                    <div />
                                  ) : (
                                    liabilityList.map((item, i) => (
                                      <li key={i}>
                                        <div
                                          className='d-flex d-flex-content'
                                          style={{
                                            justifyContent: 'space-between',
                                            padding: '8px 0',
                                            borderBottom: '1px solid rgba(163,30,35, 0.1)',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                          }}>
                                          <span>{item.accNo}</span>
                                          <span>
                                            {item.accCurrecny}
                                            <NumberFormat
                                              className='ml-1'
                                              value={item.balance}
                                              displayType={'text'}
                                              thousandSeparator={true}
                                              prefix={''}
                                              fixedDecimalScale={true}
                                              decimalScale={2}
                                              allowEmptyFormatting
                                            />
                                          </span>
                                        </div>
                                      </li>
                                    ))
                                  )}
                                </ul>
                              </AccordionItemPanel>
                            </Fragment>
                          )}
                        </AccordionItemState>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </div>
              </div>
            </Card>
          </CardDeck>
        </div>
      )}
    </LayoutWithOutAccountCard>
  )
}
